import { deleteCookie, setCookie } from 'cookies-next';
import { getValidLocale } from './language/language.utils';
import { GetServerSidePropsContext } from 'next';
import cookiesConstants from '@/constants/cookies.constants';
function setLanguageCookie(
  language: string | null | undefined,
  req?: GetServerSidePropsContext['req'],
  res?: GetServerSidePropsContext['res']
) {
  const locale = getValidLocale(language ?? 'en');
  deleteCookie(cookiesConstants.COOKIES.NEXT_LOCALE.name, { req, res });
  setCookie(cookiesConstants.COOKIES.NEXT_LOCALE.name, locale.toLowerCase(), { req, res });
}

export { setLanguageCookie };
